import { useEffect, useState } from 'react';

/** `value`, but only after it has stood still for `ms` (typing in a search box asks once, not per key). */
export function useDebounced<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
}
